const SET_SELECTED_PAYMENT_AUTH_ID = "setSelectedPaymentAuthId";
const SET_REMEMBER_NEW_CARD = "setRememberNewCard";
const SET_CARD_LIST = "setCardList";
const SET_SELECTED_PAYMENT_TYPE = "setSelectedPaymentType";
const SET_SELECTED_GATEWAY_CLIENT = "setSelectedGatewayClient";
const SET_PAYMENT_ADDITIONAL_DATA = "setPaymentAdditionalData";
const SET_IS_LOADING = "setIsLoading";
const SET_RESPONSE_MESSAGE = "setResponseMessage";
const SET_PAYMENT_PARAMETERS = "setPaymentParameters";
const RESET_PAYMENT_UI = "resetPaymentUi";

const state = {
  selectedPaymentAuthId: undefined,
  rememberNewCard: false,
  cardList: [],
  selectedPaymentType: undefined,
  selectedGatewayClient: undefined,
  paymentAdditionalData: {},
  isLoading: false,
  responseMessage: undefined,
  paymentParameters: undefined
};

const getters = {};

const actions = {
  [SET_SELECTED_PAYMENT_TYPE]({ commit }, selectedPaymentType) {
    commit(SET_SELECTED_PAYMENT_TYPE, selectedPaymentType);
  },
  [SET_SELECTED_GATEWAY_CLIENT]({ commit }, selectedGatewayClient) {
    commit(SET_SELECTED_GATEWAY_CLIENT, selectedGatewayClient);
  },
  [SET_SELECTED_PAYMENT_AUTH_ID]({ commit }, paymentAuthId) {
    commit(SET_SELECTED_PAYMENT_AUTH_ID, paymentAuthId);
  },
  [SET_REMEMBER_NEW_CARD]({ commit }, remember) {
    commit(SET_REMEMBER_NEW_CARD, remember);
  },
  [SET_CARD_LIST]({ commit }, cardList) {
    commit(SET_CARD_LIST, cardList);
  },
  [SET_PAYMENT_ADDITIONAL_DATA]({ commit }, additionalData) {
    commit(SET_PAYMENT_ADDITIONAL_DATA, additionalData);
  },
  [SET_IS_LOADING]({ commit }, isLoading) {
    commit(SET_IS_LOADING, isLoading);
  },
  [SET_RESPONSE_MESSAGE]({ commit }, responseMessage) {
    commit(SET_RESPONSE_MESSAGE, responseMessage);
  },
  [SET_PAYMENT_PARAMETERS]({ commit }, paymentParameters) {
    commit(SET_PAYMENT_PARAMETERS, paymentParameters);
  },
  [RESET_PAYMENT_UI]({ commit }) {
    commit(RESET_PAYMENT_UI);
  }
};

const mutations = {
  [SET_SELECTED_PAYMENT_TYPE]: (state, selectedPaymentType) => {
    state.selectedPaymentType = selectedPaymentType;
  },
  [SET_SELECTED_GATEWAY_CLIENT]: (state, selectedGatewayClient) => {
    state.selectedGatewayClient = selectedGatewayClient;
  },
  [SET_SELECTED_PAYMENT_AUTH_ID]: (state, paymentAuthId) => {
    state.selectedPaymentAuthId = paymentAuthId;
  },
  [SET_REMEMBER_NEW_CARD]: (state, remember) => {
    state.rememberNewCard = remember;
  },
  [SET_CARD_LIST]: (state, cardList) => {
    state.cardList = cardList;
  },
  [SET_PAYMENT_ADDITIONAL_DATA]: (state, additionalData) => {
    state.paymentAdditionalData = additionalData;
  },
  [SET_IS_LOADING]: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  [SET_RESPONSE_MESSAGE]: (state, responseMessage) => {
    state.responseMessage = responseMessage;
  },
  [SET_PAYMENT_PARAMETERS]: (state, paymentParameters) => {
    state.paymentParameters = paymentParameters;
  },
  [RESET_PAYMENT_UI]: state => {
    state.selectedPaymentAuthId = undefined;
    state.rememberNewCard = false;
    state.paymentAdditionalData = {};
    state.isLoading = false;
    state.responseMessage = undefined;
    state.selectedGatewayClient = undefined;
    // Note: selectedPaymentType, cardList and paymentParameters are intentionally NOT reset (matching Pinia behavior of Vue3 repo)
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
